import React from "react";

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="15"
      fill="none"
      viewBox="0 0 21 15"
    >
      <path
        fill="#0B223C"
        d="M.318 3.523a.809.809 0 00-.075 1.221c.352.356.955.386 1.348.068L.318 3.523zm19.09 1.289c.394.318.997.288 1.349-.068a.809.809 0 00-.075-1.22l-1.273 1.288zM10.5 12.97c-.527 0-.955.387-.955.864 0 .478.428.865.955.865v-1.73zm.01 1.729c.527 0 .954-.387.954-.865 0-.477-.427-.864-.955-.864V14.7zm2.558-3.424c.39.321.994.295 1.349-.058a.809.809 0 00-.064-1.222l-1.285 1.28zm3.21-3.2c.39.322.994.296 1.35-.057a.809.809 0 00-.065-1.222l-1.284 1.28zm-9.63 1.92a.809.809 0 00-.065 1.222c.355.353.959.38 1.349.058l-1.285-1.28zM3.436 6.797a.809.809 0 00-.064 1.222c.355.353.958.379 1.348.058l-1.284-1.28zM1.59 4.812C3.956 2.894 7.077 1.729 10.5 1.729V0C6.589 0 3.02 1.333.318 3.523l1.273 1.289zM10.5 1.729c3.423 0 6.544 1.165 8.909 3.083l1.273-1.289C17.981 1.333 14.411 0 10.5 0v1.73zm0 12.971h.01v-1.73h-.01v1.73zm0-4.323c.99 0 1.89.34 2.568.899l1.285-1.28c-1.017-.837-2.37-1.349-3.853-1.349v1.73zm0-4.324c2.226 0 4.252.766 5.779 2.024l1.284-1.28C15.7 5.261 13.22 4.324 10.5 4.324v1.729zm-2.568 5.223c.679-.56 1.578-.9 2.568-.9V8.648c-1.483 0-2.836.512-3.853 1.35l1.285 1.279zm-3.21-3.2C6.247 6.82 8.273 6.054 10.5 6.054v-1.73c-2.72 0-5.199.938-7.063 2.474l1.284 1.28z"
      ></path>
    </svg>
  );
}

export default Icon;
